interface HeaderProps {
  onPaperRequestClick: () => void;
  onInquiryClick: () => void;
}

export default function Header({ onPaperRequestClick, onInquiryClick }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center cursor-pointer">
              <img 
                src="./image/e1614dead64114cd6f4a8a63fb2000b8.png" 
                alt="インフォレスタ" 
                className="h-10 sm:h-12 w-auto object-contain"
              />
            </a>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center gap-2 sm:gap-4">
            <button
              onClick={onPaperRequestClick}
              className="px-3 sm:px-6 py-2 sm:py-2.5 bg-teal-600 text-white rounded-lg font-semibold text-xs sm:text-sm hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer"
            >
              論文見積依頼（無料）
            </button>
            <button
              onClick={onInquiryClick}
              className="px-3 sm:px-6 py-2 sm:py-2.5 bg-blue-600 text-white rounded-lg font-semibold text-xs sm:text-sm hover:bg-blue-700 transition-all whitespace-nowrap cursor-pointer"
            >
              お問合せ
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
